import { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Flex } from 'antd';

import settingsImage from 'assets/images/titles/settings.webp';
import { SettingsAbout, SettingsNotifications } from 'entities/User';
import { useBackButton } from 'shared/hooks';
import { EMainRoutes } from 'shared/typings';
import { Content, Page, PageTitle } from 'shared/ui';

interface ISettingsProps extends HTMLAttributes<HTMLDivElement> {}

export const Settings: FC<ISettingsProps> = ({ ...props }) => {
	const { t } = useTranslation();
	useBackButton(`${EMainRoutes.DASHBOARD}`);

	return (
		<Page {...props}>
			<PageTitle
				image={<img src={settingsImage} height={80} width={80} alt="profile" />}
				subtitle={t('Здесь можно изменить предпочтения и управлять уведомлениями')}>
				{t('Настройки')}
			</PageTitle>
			<Content>
				<Flex vertical gap={8}>
					<SettingsNotifications />
					<SettingsAbout />
					{/*TODO:*/}
					<Button danger size="small" type="text" onClick={() => console.log('Удалить аккаунт')}>
						{t('Удалить аккаунт')}
					</Button>
				</Flex>
			</Content>
		</Page>
	);
};

export default Settings;
